import { useSelector } from "react-redux";
import { NotificationIntent } from "widgets";

import { type Notification as NotificationGql, NotificationTypeEnum, type User } from "@/graphql.ts";
import { type IAppState } from "@/redux/reducer.ts";
import { NOTIFICATION_STATUS } from "@/settings/settings.ts";

export function getNotificationIntent(notification: NotificationGql): NotificationIntent {
  let result = NotificationIntent.Info;

  switch (notification.status) {
    case NOTIFICATION_STATUS.ERROR:
    case NOTIFICATION_STATUS.TERMINATED:
      result = NotificationIntent.Error;
      break;
    case NOTIFICATION_STATUS.COMPLETE:
      result = NotificationIntent.Success;
      break;
    // All other cases are info
  }

  return result;
}

export const useGetNotificationUser = (notification: NotificationGql) => {
  const currentUser = useSelector<IAppState, User>((state) => state.auth.session);
  let user: User | null | undefined;

  switch (notification.type) {
    case NotificationTypeEnum.Job:
      user = notification.playbookEvent?.job?.owner;
      break;
    case NotificationTypeEnum.ProjectActivity:
      user = notification.activity?.user;
      break;
    case NotificationTypeEnum.Workflow:
      user = notification.playbookEvent?.owner ?? currentUser; // there may be no playbook event with old workflow notifications
      break;
    default:
      user = currentUser;
  }

  return user;
};
